@if (isMatMenu) {
  <button mat-menu-item
          [ngClass]="cssClass"
          [matTooltip]="tooltipLabel()"
          [matTooltipDisabled]="!iconOnly"
          [disabled]="fileDisabled()"
          (click)="showFilePreview()"
          data-test="dms-file-preview-button-button">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-eye"></i>
    <span [hidden]="iconOnly" class="icon-label">{{ title }}</span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="showFilePreview()"
             data-test="dms-file-preview-button-button-2">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-eye"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-eye"></i>
      </ng-template>
    }
  </sk-button>
}
